// UGS sales article: source markers open the matching source in a dialog.
// Without JS (or without <dialog> support) the marker links jump to the Sources list instead.
(function () {
  // The product page has several article sections; wire the markers once.
  if (window.ugsSalesSources) return;
  window.ugsSalesSources = true;
  var dialog = document.querySelector('.ugs-sp__dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  var title = dialog.querySelector('#ugs-sp-dialog-title');
  var body = dialog.querySelector('.ugs-sp__dialog-body');

  document.querySelectorAll('.ugs-sp__src').forEach(function (marker) {
    marker.addEventListener('click', function (event) {
      var source = document.getElementById('ugs-source-' + marker.dataset.source);
      if (!source) return;
      event.preventDefault();
      title.textContent = 'Source ' + marker.dataset.source;
      body.innerHTML = source.querySelector('p').innerHTML;
      dialog.showModal();
    });
  });

  dialog.querySelector('.ugs-sp__dialog-close').addEventListener('click', function () {
    dialog.close();
  });
  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog) return;
    var rect = dialog.getBoundingClientRect();
    var outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    if (outside) dialog.close();
  });
})();
